/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationQuantityDto } from './EnumerationQuantityDto';
import {
    EnumerationQuantityDtoFromJSON,
    EnumerationQuantityDtoFromJSONTyped,
    EnumerationQuantityDtoToJSON,
} from './EnumerationQuantityDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfEnumerationQuantityDto
 */
export interface ODataPostProcessedResultsOfEnumerationQuantityDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEnumerationQuantityDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<EnumerationQuantityDto>}
     * @memberof ODataPostProcessedResultsOfEnumerationQuantityDto
     */
    value?: Array<EnumerationQuantityDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfEnumerationQuantityDto
     */
    $type?: ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEnumerationQuantityDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationQuantityDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationQuantityDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum = typeof ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfEnumerationQuantityDto interface.
 */
export function instanceOfODataPostProcessedResultsOfEnumerationQuantityDto(value?: unknown): value is ODataPostProcessedResultsOfEnumerationQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfEnumerationQuantityDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfEnumerationQuantityDtoFromJSON(json: any): ODataPostProcessedResultsOfEnumerationQuantityDto {
    return ODataPostProcessedResultsOfEnumerationQuantityDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfEnumerationQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfEnumerationQuantityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(EnumerationQuantityDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfEnumerationQuantityDtoToJSON(value?: ODataPostProcessedResultsOfEnumerationQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(EnumerationQuantityDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

